module.exports = __webpack_public_path__ + "img/thumb13.792baed6.jpg";